import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=49c5a2a0&scoped=true"
import script from "./IconPlus.vue?vue&type=script&lang=js"
export * from "./IconPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5a2a0",
  null
  
)

export default component.exports